var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "dropdown",
  "use": "dropdown-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol viewBox=\"0 0 11 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dropdown\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.0432 0.292893C1.65267 -0.0976311 1.01951 -0.097631 0.628982 0.292893C0.238457 0.683418 0.238457 1.31658 0.628982 1.70711L4.87117 5.94929L4.87162 5.94975C5.26215 6.34027 5.89531 6.34027 6.28584 5.94975C6.29439 5.94119 6.30276 5.93252 6.31094 5.92374L10.528 1.70665C10.9185 1.31613 10.9185 0.682964 10.528 0.29244C10.1375 -0.0980842 9.50433 -0.0980842 9.11381 0.29244L5.57828 3.82797L2.0432 0.292893Z\" fill=\"#878787\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/dropdown.svg
// module id = ci+a
// module chunks = 1